export function computeSizes(size = 1, sizes) {
    if (sizes == null) {
        return undefined;
    }
    // we omit the default value for xs to avoid a breaking change
    const { xl = size, lg = size, md = size, sm = size, xs } = sizes;
    return { xl, lg, md, sm, xs };
}
//# sourceMappingURL=computeSizes.js.map